import { render, staticRenderFns } from "./AutocompleteSearchCurrent.vue?vue&type=template&id=59ef78c2&scoped=true"
import script from "./AutocompleteSearchCurrent.vue?vue&type=script&lang=js"
export * from "./AutocompleteSearchCurrent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ef78c2",
  null
  
)

export default component.exports